import {
    AXN_COMPANY_ID_PATTERN,
    EMAIL_TEMPLATE_ID_PATTERN,
    IDENTITY_PROVIDER_ID_PATTERN,
    MESSAGING_TEMPLATE_ID_PATTERN,
    ORGANIZATION_INVITATION_ID_PATTERN,
    POLICY_COMPONENT_ID_PATTERN,
    RELYING_PARTY_ID_PATTERN,
    SERVICE_TEMPLATE_ID_PATTERN
} from "@constants/url-parameter-patterns";

export const DASHBOARD_URL = "/axnadmin/app/dashboard";
export const WORKFLOWS_URL = "/axnadmin/app/workflows";
export const WORKFLOWS_DETAILS_URL = "/axnadmin/app/workflows/:workflowId";
export const VERIFICATION_SERVICES_URL = "/axnadmin/app/verification-services";
export const VERIFICATION_SERVICES_DETAILS_URL = "/axnadmin/app/verification-services/:rpServiceId";
export const IDENTITY_PROVIDERS_URL = "/axnadmin/app/identity-providers";
export const IDENTITY_PROVIDERS_DETAILS_URL = `/axnadmin/app/identity-providers/:${IDENTITY_PROVIDER_ID_PATTERN}`;
//ORGANIZATION
export const ORGANIZATIONS_URL = "/axnadmin/app/organization/list";
export const ORGANIZATION_DETAILS_URL = `/axnadmin/app/organization/details/:${AXN_COMPANY_ID_PATTERN}`;
export const ORGANIZATION_ACTIVITY_URL = "/axnadmin/app/organization/activity";
export const ORGANIZATION_USERS_URL = "/axnadmin/app/organization/users";
export const ORGANIZATION_USERS_DETAILS_URL = "/axnadmin/app/organization/users/:axnAdminUserId";
export const ORGANIZATION_INVITATION_DETAILS_URL = `/axnadmin/app/organization/invitations/:${ORGANIZATION_INVITATION_ID_PATTERN}`;
export const ORGANIZATION_INVITATIONS_URL = "/axnadmin/app/organization/invitations";
//RELYING PARTIES
export const RELYING_PARTIES_URL = "/axnadmin/app/relying-parties";
export const RELYING_PARTIES_DETAIL_URL = `/axnadmin/app/relying-parties/:${RELYING_PARTY_ID_PATTERN}`;

// POLICY COMPONENTS
export const POLICY_COMPONENTS_URL = "/axnadmin/app/policy-components";
export const POLICY_COMPONENT_DETAILS_URL = `/axnadmin/app/policy-components/:${POLICY_COMPONENT_ID_PATTERN}`;
//ALERTS
export const ALERT_EVENTS_URL = "/axnadmin/app/alerts/alert-events"
//REPORTS
export const REPORTS_TRANSACTIONS_URL = "/axnadmin/app/reports/verification-transaction";
export const REPORTS_TRANSACTIONS_DETAILS_URL = "/axnadmin/app/reports/verification-transaction/details/:transactionId";
export const REPORTS_SERVICE_ASSERTION_PERFORMANCE_URL = "/axnadmin/app/reports/service-assertion-performance";
export const REPORTS_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_URL = "/axnadmin/app/reports/service-assertion-performance-comparison";
export const REPORTS_WORKFLOW_REPORT_URL = "/axnadmin/app/reports/workflow-report";
export const REPORTS_WORKFLOW_USAGE_DETAILS_URL = "/axnadmin/app/reports/workflow-usage-details";
export const REPORTS_FRAUD_REPORT_URL = "/axnadmin/app/reports/fraud";
export const REPORTS_USER_SUMMARY_URL = "/axnadmin/app/reports/user-summary-report";
export const REPORTS_ADAPTIVE_AUTHENTICATION_URL = "/axnadmin/app/reports/adaptive-authentication-report";
//MANAGEMENT CONSOLE
export const MANAGEMENT_CONSOLE_AXN_CACHE_URL = "/axnadmin/app/management-console/axn-console/axn-cache";
export const MANAGEMENT_CONSOLE_AXN_CONFIG_URL = "/axnadmin/app/management-console/axn-console/axn-config";
export const MANAGEMENT_CONSOLE_AXN_SESSIONS_URL = "/axnadmin/app/management-console/axn-console/axn-sessions";
export const MANAGEMENT_CONSOLE_AXN_ADMIN_CACHE_URL = "/axnadmin/app/management-console/axn-admin-console/axn-admin-cache";
export const MANAGEMENT_CONSOLE_AXN_ADMIN_CONFIG_URL = "/axnadmin/app/management-console/axn-admin-console/axn-admin-config";
export const MANAGEMENT_CONSOLE_AXN_ADMIN_LOGGING_URL = "/axnadmin/app/management-console/axn-admin-console/axn-admin-log";
export const MANAGEMENT_CONSOLE_AXN_ADMIN_SECURITY_RULES_URL = "/axnadmin/app/management-console/axn-admin-console/axn-admin-security-rule";
export const MANAGEMENT_CONSOLE_AXN_ADMIN_SECURITY_RULES_DETAILS_URL = "/axnadmin/app/management-console/axn-admin-console/axn-admin-security-rule/:axnAdminSecurityRuleId";
export const MANAGEMENT_CONSOLE_AXN_ADMIN_SESSIONS_URL = "/axnadmin/app/management-console/axn-admin-console/axn-admin-sessions";
export const MANAGEMENT_CONSOLE_MASTER_DATA_ATTRIBUTE_LABELS_URL = "/axnadmin/app/management-console/axn-master-data/attribute-labels";
export const MANAGEMENT_CONSOLE_MASTER_DATA_ATTRIBUTE_LABELS_DETAILS_URL = "/axnadmin/app/management-console/axn-master-data/attribute-labels/:axnAttributeLabelId";
export const MANAGEMENT_CONSOLE_MASTER_DATA_WORKFLOW_TEMPLATES_URL = "/axnadmin/app/management-console/axn-admin-master-data/workflow-templates";

export const MANAGEMENT_CONSOLE_MASTER_DATA_WORKFLOW_TEMPLATES_DETAILS_URL = "/axnadmin/app/management-console/axn-admin-master-data/workflow-templates/:workflowTemplateId";
export const MANAGEMENT_CONSOLE_MASTER_DATA_SERVICE_TEMPLATES_DETAILS_URL = `/axnadmin/app/management-console/axn-admin-master-data/service-templates/:${SERVICE_TEMPLATE_ID_PATTERN}`;
export const MANAGEMENT_CONSOLE_MASTER_DATA_SERVICE_TEMPLATES_URL = "/axnadmin/app/management-console/axn-admin-master-data/service-templates";
// MESSAGING TEMPLATES
export const MESSAGING_TEMPLATES_URL = "/axnadmin/app/messaging-templates";
export const MESSAGING_TEMPLATES_DETAILS_URL = `/axnadmin/app/messaging-templates/:${MESSAGING_TEMPLATE_ID_PATTERN}`;

//EMAIL_TEMPLATES
export const EMAIL_TEMPLATES_URL = "/axnadmin/app/email-templates";
export const EMAIL_TEMPLATES_DETAILS_URL = `/axnadmin/app/email-templates/:${EMAIL_TEMPLATE_ID_PATTERN}`;


export const DISCLOSURES_URL = "/axnadmin/app/disclosures";
export const HELP_URL = "/axnadmin/app/help";
export const LOGOUT_URL = "/axnadmin/app/logout";
export const LOGIN_URL = "/axnadmin/app/login";
